import { PARENT_ROUTE as ADMIN_PARENT_ROUTE } from './admin';

const GAMIFICATION_PARENT_ROUTE = '/gamification';
const ADMIN_GAMIFICATION_PARENT_ROUTE = `${ADMIN_PARENT_ROUTE}${GAMIFICATION_PARENT_ROUTE}`;
const BADGE_GROUP = 'badge-group';
const BADGE = 'badge';
const GAME_KIT = 'game-kit';
const LEADERBOARD = 'leaderboard';
const STREAK = 'streak';
const gamificationAdminRoutes = {
  GamificationManagerActive: () => `${ADMIN_GAMIFICATION_PARENT_ROUTE}/active`,
  GamificationManagerArchived: () => `${ADMIN_GAMIFICATION_PARENT_ROUTE}/archived`,
  GamificationGameKit: () => `${ADMIN_GAMIFICATION_PARENT_ROUTE}/${GAME_KIT}`,

  // badge group
  GamificationBadgeGroupCreate: () => `${ADMIN_GAMIFICATION_PARENT_ROUTE}/${BADGE_GROUP}/create`,
  GamificationBadgeGroupEdit: (id: string) =>
    `${ADMIN_GAMIFICATION_PARENT_ROUTE}/${BADGE_GROUP}/edit/${id}`,
  GamificationBadgeGroupDuplicate: (id: string) =>
    `${ADMIN_GAMIFICATION_PARENT_ROUTE}/${BADGE_GROUP}/${id}/create`,
  GamificationViewBadgeGroup: (id: string) =>
    `${ADMIN_GAMIFICATION_PARENT_ROUTE}/${BADGE_GROUP}/${id}`,
  GamificationBadgeGroupActive: () => `${ADMIN_GAMIFICATION_PARENT_ROUTE}/badge-group/active`,
  GamificationBadgeGroupArchived: () => `${ADMIN_GAMIFICATION_PARENT_ROUTE}/badge-group/archived`,
  GamificationBadgeGroupPublish: (id: string) =>
    `${ADMIN_GAMIFICATION_PARENT_ROUTE}/${BADGE_GROUP}/publish/${id}`,

  // points
  GamificationPointsActive: () => `${ADMIN_GAMIFICATION_PARENT_ROUTE}/points/active`,
  GamificationPointsArchived: () => `${ADMIN_GAMIFICATION_PARENT_ROUTE}/points/archived`,
  GamificationPointView: (id: string) => `${ADMIN_GAMIFICATION_PARENT_ROUTE}/points/${id}`,

  // badge
  GamificationBadgeCreate: () => `${ADMIN_GAMIFICATION_PARENT_ROUTE}/${BADGE}/create`,
  GamificationBadgeActive: () => `${ADMIN_GAMIFICATION_PARENT_ROUTE}/badge/active`,
  GamificationBadgeArchived: () => `${ADMIN_GAMIFICATION_PARENT_ROUTE}/badge/archived`,
  GamificationBadgePublish: (id: string) =>
    `${ADMIN_GAMIFICATION_PARENT_ROUTE}/badge/publish/${id}`,
  GamificationBadgeEdit: (id: string) => `${ADMIN_GAMIFICATION_PARENT_ROUTE}/${BADGE}/edit/${id}`,
  GamificationBadgeView: (id: string) => `${ADMIN_GAMIFICATION_PARENT_ROUTE}/${BADGE}/${id}`,

  //leaderboard
  GamificationLeaderboardCreate: () => `${ADMIN_GAMIFICATION_PARENT_ROUTE}/${LEADERBOARD}/create`,
  GamificationLeaderboardActive: () => `${ADMIN_GAMIFICATION_PARENT_ROUTE}/${LEADERBOARD}/active`,
  GamificationLeaderboardArchived: () =>
    `${ADMIN_GAMIFICATION_PARENT_ROUTE}/${LEADERBOARD}/archived`,
  GamificationLeaderboardEdit: (id: string) =>
    `${ADMIN_GAMIFICATION_PARENT_ROUTE}/${LEADERBOARD}/edit/${id}`,
  GamificationLeaderboardView: (id: string) =>
    `${ADMIN_GAMIFICATION_PARENT_ROUTE}/${LEADERBOARD}/${id}`,
  GamificationLeaderboardPublish: (id: string) =>
    `${ADMIN_GAMIFICATION_PARENT_ROUTE}/${LEADERBOARD}/publish/${id}`,

  //streaks
  GamificationStreakCreate: () => `${ADMIN_GAMIFICATION_PARENT_ROUTE}/${STREAK}/create`,
  GamificationStreakActive: () => `${ADMIN_GAMIFICATION_PARENT_ROUTE}/${STREAK}/active`,
  GamificationStreakArchived: () => `${ADMIN_GAMIFICATION_PARENT_ROUTE}/${STREAK}/archived`,
  GamificationStreakView: (id: string) => `${ADMIN_GAMIFICATION_PARENT_ROUTE}/${STREAK}/${id}`,
  GamificationStreakEdit: (id: string) => `${ADMIN_GAMIFICATION_PARENT_ROUTE}/${STREAK}/edit/${id}`,
  GamificationStreakPublish: (id: string) =>
    `${ADMIN_GAMIFICATION_PARENT_ROUTE}/${STREAK}/publish/${id}`,
};

export default gamificationAdminRoutes;
